import React, { Component } from 'react'

export default class AttendanceCustomReports extends Component {
  render() {
    return (
      <div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-custom-reports/index.js